module.exports = __webpack_public_path__ + "static/media/lineicons-alt.2c8d186e.svg";